export default "__VITE_ASSET__ab4tDqyB__"